module.exports = __webpack_public_path__ + "img/contoh image preview.1ef0dff6.png";